import { render, staticRenderFns } from "./CalledsByMonth.vue?vue&type=template&id=788ab482"
import script from "./CalledsByMonth.vue?vue&type=script&lang=js"
export * from "./CalledsByMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports